import { Component, Input, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { messageErrorLogin, AuthService, User } from '../../core';
import { SnackbarService } from '../../shared';

import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  @Input() allWidth: boolean = false;
  public hidePassword = true;
  public hideNewPassword = true;
  public hideNewPasswordTwo = true;
  public isSubmitting = false;
  public error = '';
  public form: FormGroup;
  public validation_messages = messageErrorLogin;

  constructor(formBuilder: FormBuilder, public authService: AuthService, private router: Router, private snakbarService: SnackbarService) {
    this.form = formBuilder.group({
      username: [
        null,
        [Validators.required]
      ],
      password_group: new FormGroup({
        newPassword: new FormControl('', Validators.compose([
           Validators.minLength(11),
           Validators.required,
           Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[#$%&!.])[a-zA-Z0-9#$%&!.]+$'),
        ])),
        passwordNewTwo: new FormControl('', Validators.required)
      }, (formGroup: FormGroup) => {
         return this.isIdentical(formGroup);
      }),
      password: ['', [Validators.required]],
    });
  }

  ngOnInit() {
    const auth04Username = sessionStorage.getItem('auth04_username');
    if (auth04Username) {
      this.form.controls['username'].setValue(auth04Username);
    } else {
      this.authService.user.subscribe((user: User) => {
        this.form.controls['username'].setValue(user.username);
      });
    }
  }

  onSubmit() {
    const request = this.form.value;
    this.authService.changePassword({...request, ...request.password_group}).subscribe(response => {
      const snackRef = this.snakbarService.show('Su contraseña fue modificada satisfactoriamente', 'success');
      snackRef.afterDismissed().subscribe(() => {
        const auth04PasswordChange = sessionStorage.getItem('auth04_password_change');
        if (auth04PasswordChange === 'true') {
          sessionStorage.removeItem('auth04_password_change');
          sessionStorage.removeItem('auth04_username');
          this.router.navigate(['/iniciar-sesion']);
        } else {
          this.authService.logout();
          location.reload();
        }
      });
    }, error => {
      this.snakbarService.show(error, 'error');
      this.isSubmitting = false;
    });
    this.error = '';
  }

  isIdentical(formGroup: FormGroup) {
    let value;
    let valid = true;
    for (const or in formGroup.controls) {
      if (formGroup.controls.hasOwnProperty(or)) {
        const control: FormControl = <FormControl>formGroup.controls[or];
        if (value === undefined) {
          value = control.value;
        } else {
          if (value !== control.value) {
            valid = false;
            break;
          }
        }
      }
    }

    if (valid) {
      return null;
    }
    return {isIdentical: true};
  }
}
